import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={18}
    fill="none"
    viewBox="0 0 22 18"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.725 18a.973.973 0 0 1-.85-.5 1.098 1.098 0 0 1-.138-.488.898.898 0 0 1 .138-.512l9.25-16c.1-.167.23-.292.387-.375C10.672.042 10.833 0 11 0c.167 0 .33.042.488.125a.984.984 0 0 1 .387.375l9.25 16c.1.167.146.337.137.512a1.098 1.098 0 0 1-.137.488.973.973 0 0 1-.85.5zm1.725-2h15.1L11 3zM11 15c.283 0 .52-.096.713-.287A.968.968 0 0 0 12 14a.968.968 0 0 0-.287-.713A.968.968 0 0 0 11 13a.968.968 0 0 0-.713.287A.968.968 0 0 0 10 14c0 .283.096.52.287.713.192.191.43.287.713.287m0-3c.283 0 .52-.096.713-.287A.968.968 0 0 0 12 11V8a.967.967 0 0 0-.287-.713A.968.968 0 0 0 11 7a.968.968 0 0 0-.713.287A.967.967 0 0 0 10 8v3c0 .283.096.52.287.713.192.191.43.287.713.287"
    />
  </svg>
);
export default SvgWarning;
